export default __webpack_public_path__ + "static/media/style-belgardSlate.456a0e42.jpg";